export const isAssignedToEvent = (event, address) => {
  const email = String(address || '').trim().toLowerCase();
  if (!email) return false;
  const legacy = Array.isArray(event?.allowedUsers) ? event.allowedUsers :
    typeof event?.allowedUsers === 'string' ? event.allowedUsers.split(',') : [];
  return legacy.some((entry) => String(entry).trim().toLowerCase() === email) ||
    (Array.isArray(event?.usersAllowed) && event.usersAllowed.some((entry) =>
      String(entry?.name || entry).trim().toLowerCase() === email));
};
